import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaRestosPagar: ['administracao'],
    removeExercicioInicialConsultaRestosPagar: [],
    removeExercicioFinalConsultaRestosPagar: [],
    removeNumeroEmpenhoInicialConsultaRestosPagar: [],
    removeNumeroEmpenhoFinalConsultaRestosPagar: [],
    removeDataEmpenhoInicialConsultaRestosPagar: [],
    removeDataEmpenhoFinalConsultaRestosPagar: [],
    removeDataVencimentoInicialConsultaRestosPagar: [],
    removeDataVencimentoFinalConsultaRestosPagar: [],
    removeRecursoConsultaRestosPagar: [],
    removeDestinacaoConsultaRestosPagar: [],
    setMostraAplicarFiltroConsultaRestosPagar: [],
    limpaFiltroConsultaRestosPagar: [],
    aplicarFiltroConsultaRestosPagar: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicioInicial: '',
    exercicioFinal: '',
    numeroEmpenhoInicial: '',
    numeroEmpenhoFinal: '',
    dataEmpenhoInicial: '',
    dataEmpenhoFinal: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    recurso: [],
    destinacao: [],
    mostraAplicarFiltro: false,
    status: '',
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioFinal: '', mostraAplicarFiltro: true }
}
const removeNumeroEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeNumeroEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeDataEmpenhoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoInicial: '', mostraAplicarFiltro: true }
}
const removeDataEmpenhoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataEmpenhoFinal: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: '', mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_RESTOS_PAGAR]: removeAdministracao,
    [Types.REMOVE_EXERCICIO_FINAL_CONSULTA_RESTOS_PAGAR]: removeExercicioFinal,
    [Types.REMOVE_NUMERO_EMPENHO_INICIAL_CONSULTA_RESTOS_PAGAR]: removeNumeroEmpenhoInicial,
    [Types.REMOVE_NUMERO_EMPENHO_FINAL_CONSULTA_RESTOS_PAGAR]: removeNumeroEmpenhoFinal,
    [Types.REMOVE_DATA_EMPENHO_INICIAL_CONSULTA_RESTOS_PAGAR]: removeDataEmpenhoInicial,
    [Types.REMOVE_DATA_EMPENHO_FINAL_CONSULTA_RESTOS_PAGAR]: removeDataEmpenhoFinal,
    [Types.REMOVE_DATA_VENCIMENTO_INICIAL_CONSULTA_RESTOS_PAGAR]: removeDataVencimentoInicial,
    [Types.REMOVE_DATA_VENCIMENTO_FINAL_CONSULTA_RESTOS_PAGAR]: removeDataVencimentoFinal,
    [Types.REMOVE_RECURSO_CONSULTA_RESTOS_PAGAR]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_RESTOS_PAGAR]: removeDestinacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_RESTOS_PAGAR]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_RESTOS_PAGAR]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_RESTOS_PAGAR]: aplicarFiltro,
})
